var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('EditorHeaderMobile',_vm._g(_vm._b({},'EditorHeaderMobile',_vm.headerProps,false),_vm.headerEmits)):_c('EditorHeaderDesktop',_vm._g(_vm._b({},'EditorHeaderDesktop',_vm.headerProps,false),_vm.headerEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }